const itemFormDefaults = {
  name: '',
  slug: '',
  layout: '',
  description: '',
  structuredContent: [],
  media: [],
  categories: [],
  marker: '',
  locationType: 'point',
  defaultItem: false,
  countries: [],
  latitude: null,
  longitude: null,
};

export default itemFormDefaults;
